import { render } from "./pending_Return_Request_Approval.vue?vue&type=template&id=c71cab76&scoped=true"
import script from "./pending_Return_Request_Approval.vue?vue&type=script&lang=js"
export * from "./pending_Return_Request_Approval.vue?vue&type=script&lang=js"

import "./pending_Return_Request_Approval.vue?vue&type=style&index=0&id=c71cab76&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c71cab76"]])

export default __exports__